"use client"

import { Accordion, FilterCheckboxOption } from "@/components/molecules"
import useFilters from "@/hooks/useFilters"
import { useTranslate } from "@tolgee/react"

const filters = [
  { label: "filters.condition_new", amount: 78 },
  { label: "filters.condition_new_with_tags", amount: 40 },
  { label: "filters.condition_used_excellent", amount: 7 },
  { label: "filters.condition_used_good", amount: 16 },
  { label: "filters.condition_used_fair", amount: 0 },
]

export const ConditionFilter = () => {
  const { updateFilters, isFilterActive } = useFilters("condition")
  const { t } = useTranslate()

  const selectHandler = (option: string) => {
    updateFilters(option)
  }

  return (
    <Accordion heading={t("filters.condition_heading")}>
      <ul className="px-4">
        {filters.map(({ label, amount }) => (
          <li key={label} className="mb-4">
            <FilterCheckboxOption
              checked={isFilterActive(label)}
              disabled={Boolean(!amount)}
              onCheck={selectHandler}
              label={t(label)}
              amount={amount}
            />
          </li>
        ))}
      </ul>
    </Accordion>
  )
}
